import { Status } from 'generated/graphql';

/*
 ** Enum is already defined in the backend
 */
export const FINAL_STATUSES = [Status.CLOSED, Status.COMPLETED];
